export const GET_NZ_VARIABLES_SUCCESS = 'GET_NZ_VARIABLES_SUCCESS'
export const RESET_VARIABLES_SUCCESS = 'RESET_VARIABLES_SUCCESS'
export const SET_THEME_COLORS_SUCCESS = 'SET_THEME_COLORS_SUCCESS'
export const SET_BROWSER_TAB_SUCCESS = 'SET_BROWSER_TAB_SUCCESS'